import { connect } from 'react-redux';
import { branch, compose } from 'recompose';

import { dispatchInitFormData, dispatchCreateOrUpdateTimeEntry } from '../actions';

import TimeEntryCreateEditFormWithDateWrapper from './TimeEntryCreateEditFormWithDateWrapper';
import { queryTimeEntryGQL } from '../graphql';

const mapStateToProps = (state) => {
  return {
  };
};

const mapDispatchToProps = {
  dispatchInitFormData,
  dispatchCreateOrUpdateTimeEntry,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

// ORDER MATTERS. If you want redux to put the props in required for queries
// you better withRedux FIRST
const enhance = compose(
  withRedux,
  branch(
    (props) => { return !!props.timeEntryId; },
    queryTimeEntryGQL,
  ),
);

export default enhance(TimeEntryCreateEditFormWithDateWrapper);
